import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GoogleMapUtil from '../../utils/googleMap';
import styles from './styles.scss';
import defaultMapStyle from './mapStyle';

const defaultMapOptions = {
  center: {
    lat: 51.509965,
    lng: -0.091437,
  },
  mapTypeId: 'roadmap',
  zoom: 16,
  styles: defaultMapStyle,
  streetViewControl: false,
  rotateControl: false,
  mapTypeControl: false,
  fullscreenControl: false,
  gestureHandling: 'cooperative',
  backgroundColor: '#f4f5f5',
};

export class GoogleMap extends Component {
  componentDidMount() {
    const { googleApiKey, onInit } = this.props;

    this.googleMapUtil = new GoogleMapUtil();

    this.googleMapUtil.load(googleApiKey).then(() => {
      this.initMap();

      // Wait for the projection to change, otherwise map.getProjection() won't work
      this.googleMapUtil.map.addListener('projection_changed', () => {
        onInit(this.googleMapUtil);
      });
    });
  }

  initMap() {
    if (this.mapEl && !this.googleMapUtil.map) {
      const mapOptions = Object.assign({}, defaultMapOptions, this.props.options);

      this.googleMapUtil.createMap(this.mapEl, mapOptions);
    }
  }

  render() {
    return (
      <div
        className={styles['google-map']}
        ref={(mapEl) => {
          this.mapEl = mapEl;
        }}
      />
    );
  }
}

GoogleMap.defaultProps = {
  googleApiKey: '',
  onInit: () => {},
  options: {},
};

GoogleMap.propTypes = {
  googleApiKey: PropTypes.string,
  onInit: PropTypes.func,
  options: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

export default connect(({ request }) => ({
  googleApiKey: request.googleApiKey,
}))(GoogleMap);
